import _ from '../../utils/LodashImports';

const getLabels = (appCtx) => {
  const textDictionary = _.get(appCtx, 'siteConfig.textDictionary', {});
  return {
    addProductsBanner: {
      add: _.get(textDictionary, 'WHOLESALE_BANNER_BANNER_ADD_PRODUCTS_BANNER_ADD', 'Agrega'),
      units: _.get(textDictionary, 'WHOLESALE_BANNER_BANNER_ADD_PRODUCTS_BANNER_UNITS', 'un.'),
      toActivate: _.get(
        textDictionary,
        'WHOLESALE_BANNER_BANNER_ADD_PRODUCTS_BANNER_TO_ACTIVATE',
        'más para activar la promoción.'
      ),
      toActivateMore: _.get(
        textDictionary,
        'WHOLESALE_BANNER_BANNER_ADD_PRODUCTS_BANNER_TO_ACTIVATE_MORE',
        'más para activar otra promoción.'
      ),
    },
    readyBanner: {
      text1: _.get(textDictionary, 'WHOLESALE_BANNER_BANNER_READY_BANNER_TEXT_1', '¡Listo!'),
      text2: _.get(textDictionary, 'WHOLESALE_BANNER_BANNER_READY_BANNER_TEXT_2', 'Activaste la promoción.'),
    },
    promotionActive: {
      single: _.get(textDictionary, 'WHOLESALE_BANNER_BANNER_PROMOTION_ACTIVE_SINGLE', 'promoción activada'),
      multiple: _.get(textDictionary, 'WHOLESALE_BANNER_BANNER_PROMOTION_ACTIVE_MULTIPLE', 'promociones activadas'),
    },
  };
};

export default getLabels;
